export default {
  "b2b.zdroje-grid.title": "Resources",
  "b2b.zdroje-grid.add": "Add resource"
};
